<div class="image-editor-container">
  <div class="image-editor-row">
    <div class="image-editor-column">
      <div class="canvas-container" *ngIf="!croppedPhoto">
        <img [src]="url" />
      </div>
      <div class="preview-container" *ngIf="croppedPhoto">
        <img [src]="croppedUrl" />
      </div>
    </div>
  </div>
  <div class="image-editor-row">
    <div class="image-editor-column image-editor-center">
      <sn-icon-button *ngIf="!croppedPhoto" (click)="crop()"
        ><sn-icon>crop</sn-icon></sn-icon-button
      >
      <sn-icon-button *ngIf="croppedPhoto" (click)="undo()"><sn-icon>undo</sn-icon></sn-icon-button>
    </div>
  </div>
</div>
